export var ExtensionsEventsEnum;
(function (ExtensionsEventsEnum) {
    ExtensionsEventsEnum["IS_SHOWING_WHITEBOARD"] = "extension:isShowingWhiteboard";
    ExtensionsEventsEnum["IS_SHOWING_ADHERELY"] = "extension:isShowingAdherely";
})(ExtensionsEventsEnum || (ExtensionsEventsEnum = {}));
export var MenuItemName;
(function (MenuItemName) {
    MenuItemName["SCREENSHARING"] = "screensharing";
})(MenuItemName || (MenuItemName = {}));
export var MenuTypesName;
(function (MenuTypesName) {
    MenuTypesName["CALL_MENU"] = "callMenu";
    MenuTypesName["MAIN_MENU"] = "mainMenu";
})(MenuTypesName || (MenuTypesName = {}));
export var TargetItemName;
(function (TargetItemName) {
    TargetItemName["ROOM"] = "room";
    TargetItemName["USER"] = "user";
})(TargetItemName || (TargetItemName = {}));
export var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["SUCCESS"] = "SUCCESS";
    NotificationTypes["ERROR"] = "ERROR";
    NotificationTypes["WARNING"] = "WARNING";
})(NotificationTypes || (NotificationTypes = {}));
export var ClientTypeMarker;
(function (ClientTypeMarker) {
    ClientTypeMarker["INTERPRETER"] = "interpreter";
})(ClientTypeMarker || (ClientTypeMarker = {}));
export var PEOPLE_TYPES;
(function (PEOPLE_TYPES) {
    PEOPLE_TYPES["doctor"] = "doctor";
    PEOPLE_TYPES["patient"] = "patient";
})(PEOPLE_TYPES || (PEOPLE_TYPES = {}));
export var PEOPLE_STATUS;
(function (PEOPLE_STATUS) {
    PEOPLE_STATUS["VIDEO"] = "video";
    PEOPLE_STATUS["PENDING"] = "pending";
    PEOPLE_STATUS["AVAILABLE"] = "available";
    PEOPLE_STATUS["OFFLINE"] = "offline";
})(PEOPLE_STATUS || (PEOPLE_STATUS = {}));
export var VIDEO_QUALITY;
(function (VIDEO_QUALITY) {
    VIDEO_QUALITY["LOW"] = "ld";
    VIDEO_QUALITY["MEDIUM"] = "sd";
    VIDEO_QUALITY["HIGH"] = "hd";
})(VIDEO_QUALITY || (VIDEO_QUALITY = {}));
